module.exports = __webpack_public_path__ + "img/Centerparks.c9ef2eb6.svg";